import axios from "axios";

const axiosIns = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
axiosIns.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user?.accessToken) {
      config.headers["Authorization"] = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default axiosIns;
